export interface BackendSubscriptionEvent {
  ev: string;
  ids?: (number | string)[];
  timestamp?: number;
}

export interface BackendSubscriptionQuery<D> {
  event: string;
  ids?: (number | string)[];
  action: BackendSubscriptionAction;
  writeData?: (event: BackendSubscriptionEvent, data?: D) => D;
  writeItem?: (event: BackendSubscriptionEvent, data: D) => D;
  itemSelector?: (data: D) => number | string;
}

export enum BackendSubscriptionAction {
  UPDATE = 'UPDATE',
  CREATE = 'CREATE',
  DELETE = 'DELETE'
}
